import { action } from 'easy-peasy';
import type { Action } from 'easy-peasy';

export type ClassicLinkContextStore = {
  hadActiveSelection: boolean;
  setHadActiveSelection: Action<ClassicLinkContextStore, boolean>;
};

export const classicLinkContextStore: ClassicLinkContextStore = {
  hadActiveSelection: false,
  setHadActiveSelection: action((state, payload) => {
    state.hadActiveSelection = payload;
  }),
};
